import { useEffect, useState } from 'react';
import { useMasterData } from '../../context/MasterDataContext';

const useBaki = () => {
  const [bakiOptionId, setBakiOptionId] = useState('');
  const [bakiOption, setBakiOption] = useState([]);
  const { settings, isLoaded } = useMasterData();

  useEffect(() => {
    if (isLoaded) {
      if (settings && settings.baki_options) {
        const arr = settings.baki_options.split(',').map(item => item.trim()).filter(Boolean);
        const parsedArr = arr.map(Number);
        setBakiOption(parsedArr);
      } else {
        setBakiOption(Array.from({ length: 20 }, (_, i) => i + 1));
      }
    }
  }, [settings, isLoaded]);

  return {
    bakiOption,
    setBakiOptionId,
    bakiOptionId,
  };
};

export default useBaki;
